import React from 'react';
import { UseFormMethods } from 'react-hook-form';
// import ProvisionClause from 'src/components/common/ProvisionClause';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import RHFToggle from 'src/components/controls/tempRHFControls/RHFToggle';
import IndexReferenceType from 'src/models/IndexReferenceType';
// import carbonCapture from 'src/models/contract_types/carbonCapture';
import AgreementUtil from 'src/util/AgreementUtil';

interface ICarbonCaptureGenerationProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors'>> {
    // carbonCaptureData: carbonCapture;
    measurementTypes: Array<IndexReferenceType>;
    isInHanded: boolean;
    // totalNet?: number;
    // calculateTotal: (measurementTypeId: number, paymentAmount: number, grossAcres: number) => void;
}

const CarbonCaptureGeneration = (props: ICarbonCaptureGenerationProps) => {
    // TODO: Keeping this commented code in case similar calculations need to be made in the future.

    // useEffect(() => {
    //     handleTotals();
    // }, [props.totalNet]);

    // const handleTotals = () => {
    //     let rep = props.getValues();
    //     let netAcres = props.totalNet ? props.totalNet : 0;

    //     let primaryRentalFeeTypeId = parseInt(rep.carbonCaptureHolds[0].primaryRentalFeeTypeId, 10);
    //     let primaryRentalAmount = parseFloat(rep.carbonCaptureHolds[0].primaryRentalAmount);
    //     if (!isNaN(primaryRentalFeeTypeId) && !isNaN(primaryRentalAmount)) {
    //         let primaryRentalTotal = props.calculateTotal(primaryRentalFeeTypeId, primaryRentalAmount, netAcres);
    //         props.setValue('carbonCaptureHolds[0].primaryRentalTotal', primaryRentalTotal);
    //     }

    //     let optionFeeTypeId = parseInt(rep.carbonCaptureHolds[0].optionFeeTypeId, 10);
    //     let optionAmount = parseFloat(rep.carbonCaptureHolds[0].optionAmount);
    //     if (!isNaN(optionFeeTypeId) && !isNaN(optionAmount)) {
    //         let totalRent = props.calculateTotal(optionFeeTypeId, optionAmount, netAcres);
    //         props.setValue('carbonCaptureHolds[0].optionTotal', totalRent);
    //     }
    // };

    return (
        <div>
            <div style={{ margin: '1rem' }}>
                <div style={{ height: '100%', gap: '1rem' }}>
                    <div id="formContent">
                        <div>
                            <div>
                                <div style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Agreement Terms" />

                                    <div hidden={true}>
                                        <RHFInputBox
                                            label=""
                                            name="carbonCaptureHolds[0].id"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="carbonCaptureHolds[0].carbonCaptureId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="carbonCaptureHolds[0].projectId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="carbonCaptureHolds[0].holdNumber"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="carbonCaptureHolds[0].contractLookupId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                    </div>

                                    <div className="form-row">
                                        <RHFInputBox
                                            rules={{ required: 'field required' }}
                                            type="date"
                                            name="leaseDate"
                                            label="Lease Date"
                                            register={props.register}
                                            errors={props.errors}
                                            isRequired={true}
                                            disabled={props.isInHanded}
                                            bodyStyle={{ width: '33%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            rules={{ required: 'field required' }}
                                            type="date"
                                            name="effectiveDate"
                                            label="Effective Date"
                                            register={props.register}
                                            errors={props.errors}
                                            isRequired={true}
                                            disabled={props.isInHanded}
                                            bodyStyle={{ width: '33%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            rules={{ required: 'field required' }}
                                            type="date"
                                            name="recordedDate"
                                            label="Recorded Date"
                                            register={props.register}
                                            errors={props.errors}
                                            disabled={props.isInHanded}
                                            bodyStyle={{ width: '33%' }}
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFInputBox
                                                label="Bonus Amount"
                                                name="bonusAmount"
                                                type="number"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="bonusTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'acre')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                            />
                                            <RHFInputBox
                                                label="Coal Price"
                                                name="coalPrice"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="coalPriceTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'ton')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFToggle 
                                                name="optionExercised" 
                                                label="Option Exercised?" 
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register} 
                                                errors={props.errors} 
                                            />
                                            <RHFInputBox
                                                label="Option Amount"
                                                name="optionAmount"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="optionAmountTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'acre')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFInputBox
                                                label="Option Term"
                                                name="optionTerm"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="optionTermTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Time')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFToggle 
                                                name="secondOptionExercised" 
                                                label="Second Option Exercised?" 
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register} 
                                                errors={props.errors} 
                                            />
                                            <RHFInputBox
                                                label="Second Option Amount"
                                                name="secondOptionAmount"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="secondOptionAmountTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'acre')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFInputBox
                                                label="Second Option Term"
                                                name="secondOptionTerm"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="secondOptionTermTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Time')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFToggle 
                                                name="isRental" 
                                                label="Rental?" 
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register} 
                                                errors={props.errors} 
                                            />
                                            <RHFInputBox
                                                label="Rental Price"
                                                name="rentalPrice"
                                                type="number"
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="rentalPriceTypeId"
                                                options={AgreementUtil.getOptions(props.measurementTypes, 'Fee', 'acre')}
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFInputBox
                                                label="Operator"
                                                name="carbonCaptureHolds[0].operator"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '16%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Api No"
                                                name="carbonCaptureHolds[0].apiNo"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '16%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Unit Name"
                                                name="carbonCaptureHolds[0].unitName"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '16%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Field Name"
                                                name="carbonCaptureHolds[0].fieldName"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '16%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFInputBox
                                                label="Fed/State Lease No"
                                                name="carbonCaptureHolds[0].fedStateLeaseNo"
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '16%' }}
                                                style={{ width: '100%' }}
                                            />
                                            <RHFToggle 
                                                name="seismicDataReq" 
                                                label="Ratified / Seismic Data Required?" 
                                                bodyStyle={{ width: '20%' }} 
                                                register={props.register} 
                                                errors={props.errors} 
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFInputBox
                                                label="Royalty"
                                                name="carbonCaptureHolds[0].royalty"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                                step={0.0001}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarbonCaptureGeneration;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/CarbonCaptureComponents/CarbonCaptureGeneration.tsx